<section class="assign-app">
  <div class="header" fxLayout="row" fxLayoutAlign="space-between center">
    <h3>{{ 'common.assignApplication' | translate }}</h3>
    <mat-icon class="material-symbols-outlined close-dialog" (click)="closeDialog()"> close </mat-icon>
  </div>
  @if (!notFoundApp) {
  <div class="form">
    @for (app of appList; track app) {
    <div>
      <mat-checkbox color="primary" (change)="selectApp($event, app.id)" [(ngModel)]="app.check">{{
        app?.name
      }}</mat-checkbox>
    </div>
    }
  </div>
  <div class="action-buttons">
    <button mat-button class="cancel-btn button" (click)="closeDialog()">
      {{ 'common.cancel' | translate }}
    </button>
    <button mat-button class="submit-btn button" (click)="submit()" [ngClass]="{ disabled: disableSubmitButton}" [disabled]="disableSubmitButton">
      {{ 'common.submit' | translate }}
    </button>
  </div>
  } @if (notFoundApp) {
  <h3 class="text-center">{{ 'common.notFoundApp' | translate }}</h3>
  }
</section>
